var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cloneValidators, handleValidation, hasErrors, shouldNotValidate } from './utils';
import defaultValidators from "./validators";
import parseValidationRules from "./parseValidationRules";
class Validation {
    constructor(validationRuleParser = parseValidationRules) {
        this.validationRuleParser = validationRuleParser;
        this.listeners = [];
        this.validators = cloneValidators(defaultValidators);
        this.configs = {
            stopOnError: {},
            omitEmpty: {},
            shouldValidateFields: {},
            validateEachArrayItem: {}
        };
        this.addValidators = this.addValidators.bind(this);
        this.shouldValidate = this.shouldValidate.bind(this);
        this.messages = this.messages.bind(this);
        this.rules = this.rules.bind(this);
        this.addResultListener = this.addResultListener.bind(this);
        this.validate = this.validate.bind(this);
        this.validationRuleParser = this.validationRuleParser.bind(this);
    }
    addValidators(validators) {
        const filteredValidators = this.validators.filter(v => !validators.find(val => val.name === v.name));
        validators.forEach(v => {
            const { name, validator, errMsg } = v;
            filteredValidators.push({
                name, validator, errMsg
            });
        });
        this.validators = filteredValidators;
        return this;
    }
    shouldValidate(shouldValidateFields) {
        this.configs.shouldValidateFields = shouldValidateFields;
        return this;
    }
    messages(messages) {
        Object.keys(messages).forEach(validatorName => {
            const validator = this.validators.find(v => v.name === validatorName);
            if (validator) {
                validator.errMsg = messages[validatorName];
            }
        });
        return this;
    }
    rules(validation) {
        this.validationRules = validation;
        return this;
    }
    addResultListener(listener) {
        this.listeners.push(listener);
        return this;
    }
    validate(data, contextData) {
        const allCtxData = contextData ? contextData : data;
        const errors = {};
        const parsedValidationRules = this.validationRuleParser(this.validationRules, this.configs);
        const allPromises = Object.keys(parsedValidationRules).map((name) => __awaiter(this, void 0, void 0, function* () {
            const value = data[name];
            errors[name] = [];
            if (Array.isArray(value) && this.configs.validateEachArrayItem[name]) {
                for (const [i, v] of value.entries()) {
                    errors[name][i] = [];
                    if (yield shouldNotValidate(name, v, this.configs, allCtxData)) {
                        return;
                    }
                    for (const validatorName of Object.keys(parsedValidationRules[name])) {
                        const stop = yield handleValidation(validatorName, this.validators, name, v, parsedValidationRules, allCtxData, errors, this.configs, i);
                        if (stop) {
                            break;
                        }
                    }
                }
                return;
            }
            if (yield shouldNotValidate(name, value, this.configs, allCtxData)) {
                return;
            }
            for (const validatorName of Object.keys(parsedValidationRules[name])) {
                if (parsedValidationRules[name] instanceof Validation) {
                    yield parsedValidationRules[name].validate(value, allCtxData).catch((err) => {
                        errors[name] = err;
                    });
                    break;
                }
                const stop = yield handleValidation(validatorName, this.validators, name, value, parsedValidationRules, allCtxData, errors, this.configs);
                if (stop) {
                    return;
                }
            }
        }));
        return Promise
            .all(allPromises)
            .then(() => this.listeners.forEach(listener => listener(errors)))
            .then(() => new Promise((resolve, reject) => {
            if (hasErrors(errors)) {
                return reject(errors);
            }
            return resolve(errors);
        }));
    }
}
export default Validation;
